import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';

import language from '../../../assets/languages/language';
import AppRoutes from '../../config/AppRoutes';
import CustomButton from '../Button/CustomButton';
import CustomCard from '../CustomCard';
import CardBody from '../CustomCard/CardBody';
import CardHeader from '../CustomCard/CardHeader';
import Header from '../Header';
import LoaderWrapper from '../LoaderWrapper';
import Report from '../Report';
import Timer from '../Timer';
import {
  fetchChapterNameById,
  fetchQuestionsChapterWise,
  getTokenAndEmail,
  saveQuestionStats,
} from '../services';
import QuestionBankFooter from './QuestionBankFooter';
import FlashCard from '../../../components/FlashCard';
import { isRevisionModeActive, renderHTMLContent } from '../../../common/function';
import CustomCardHeader from '../../../Components-2025/QuestionBank/CustomCardHeader';
import ViewQuestion from '../../../Components-2025/QuestionBank/ViewQuestion';
import { EXAM_NAMES } from '../../../common/constant';
export class BeginQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stopTimer: false,
      questionData: [],
      currentQuestion: null,
      currentIndex: 0,
      showReportSection: false,
      isFlashCardHidden: true,
      isLoading: true,
      showAnswer: false,
      selectedChoice: '',
      chapterName: '',
      textColor: '',
      result: '',
      correctChoice: '',
      timeDone: 0,
    };
    this.timerValue = 0;
    this.childRef = null;
    this.setChildRef = element => {
      this.childRef = element;
    };
  }

  static contextTypes = { router: React.PropTypes.object };

  async componentDidMount() {
    window.scrollTo(0, 0);
    const { state } = this.props.location;
    let initialIndex = 0;
    if (this.props.params && this.props.params.index) {
      initialIndex = parseInt(this.props.params.index, 10) || 0;
    }

    if (state && state.questionData && state.questionData.length) {
      const { questionData } = state;
      await this.onSetCurrentQuestion(questionData, initialIndex);
      this.setState({ questionData, isLoading: false });
    } else {
      const data = {
        ...getTokenAndEmail(),
        chapterId: this.props.params.chapterId,
      };

      const response = await fetchQuestionsChapterWise(data);
      if (response.success) {
        const userId = getTokenAndEmail().user_id;
        const questions = response.question.map(q => {
          const userStats = q.esg_question_stats && q.esg_question_stats.find(stat => stat.user_id === userId);
          const selectedChoice = userStats && userStats.selected_choice ? userStats.selected_choice : '';
          return { ...q, selectedChoice };
        });
        await this.onSetCurrentQuestion(questions, initialIndex);
        this.setState({ questionData: questions, isLoading: false });
      } else {
        this.setState({ isLoading: false });
      }

      const chapterResponse = await fetchChapterNameById(data);
      if (chapterResponse.success) {
        this.setState({ chapterName: chapterResponse.chapter.name });
      }
    }
  }

  async componentDidUpdate(prevProps) {
    // If the index param changes, update the current question
    if (
      this.props.params.index !== prevProps.params.index &&
      this.state.questionData.length > 0
    ) {
      const newIndex = parseInt(this.props.params.index, 10) || 0;
      await this.onSetCurrentQuestion(this.state.questionData, newIndex);
    }
  }

  // Helper to extract stats from esg_question_stats
  getStatsFromQuestionStats(stats, correctChoice) {
    let selectedChoice = '';
    let rightAnswer = '';
    let answerStatus = '';
    let timeDone = 0;
    const isRevisionMode = isRevisionModeActive(EXAM_NAMES.ESG);
    if (stats && stats.length > 0 && isRevisionMode) {
      selectedChoice = stats[0].selected_choice || '';
      rightAnswer = stats[0].right_answer || '';
      answerStatus = stats[0].id || '';
      timeDone = stats[0].time_done || 0;
    }
    return { selectedChoice, rightAnswer, answerStatus, timeDone };
  }

  async onSetCurrentQuestion(questionsData, index) {
    let currentIndex = typeof index === 'number' ? index : 0;
    if (
      typeof currentIndex !== 'number' ||
      isNaN(currentIndex) ||
      currentIndex < 0 ||
      currentIndex >= questionsData.length
    ) {
      currentIndex = 0;
    }
    const currentQuestion = questionsData[currentIndex];

    let selectedChoice = currentQuestion.selectedChoice || '';
    let rightAnswer = '';
    let answerStatus = '';
    let timeDone = 0;

    if (currentQuestion.esg_question_stats && currentQuestion.esg_question_stats.length > 0) {
      const stats = this.getStatsFromQuestionStats(currentQuestion.esg_question_stats, currentQuestion.correctChoice);
      if (!selectedChoice) {
        selectedChoice = stats.selectedChoice;
      }
      rightAnswer = stats.rightAnswer;
      answerStatus = stats.answerStatus;
      timeDone = stats.timeDone;
    }

    const correctChoice = currentQuestion.correctChoice || '';
    let showAnswer = false;
    let selected = '';
    const isRevisionMode = isRevisionModeActive(EXAM_NAMES.ESG);

    if (selectedChoice && isRevisionMode) {
      selected = selectedChoice;
      showAnswer = true;
    } else if (answerStatus && isRevisionMode) {
      if (rightAnswer === 1) {
        selected = correctChoice;
        showAnswer = true;
      } else if (!rightAnswer) {
        const choices = Object.keys(currentQuestion)
          .filter(key => key.startsWith('choice') && key !== correctChoice);
        selected = choices.length > 0 ? choices[0] : '';
        showAnswer = true;
      }
    }

    const isChoiceCorrect = selected === correctChoice;

    // Set timer value when initializing question
    this.timerValue = timeDone;

    this.setState({
      selectedChoice: selected,
      stopTimer: !!selected,
      showAnswer,
      currentIndex,
      currentQuestion,
      correctChoice,
      textColor: isChoiceCorrect ? 'text_success' : 'text_failure',
      result: isChoiceCorrect ? 'Correct' : 'Incorrect',
      timeDone
    });
  }

  getPreviousQuestion = async () => {
    const { currentIndex, questionData } = this.state;
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      // Update URL for navigation
      this.context.router.push({
        pathname: AppRoutes.ESG_QUESTION_BANK_VIEW_QUE
          .replace(':chapterId', this.props.params.chapterId)
          .replace(':id', questionData[newIndex].id)
          .replace(':index', newIndex),
      });
      await this.onSetCurrentQuestion(questionData, newIndex);
      this.setState({
        showReportSection: false,
      })
    }
  };

  getNextQuestion = async () => {
    const { currentIndex, questionData } = this.state;
    if (currentIndex < questionData.length - 1) {
      const newIndex = currentIndex + 1;
      // Update URL for navigation
      this.context.router.push({
        pathname: AppRoutes.ESG_QUESTION_BANK_VIEW_QUE
          .replace(':chapterId', this.props.params.chapterId)
          .replace(':id', questionData[newIndex].id)
          .replace(':index', newIndex),
      });
      await this.onSetCurrentQuestion(questionData, newIndex);
      this.setState({
        showReportSection: false,
      })
    }
  };

  getTimerValue = timerValue => {
    this.timerValue = timerValue;
  };

  validateQuestion = () => {
    const { selectedChoice, currentQuestion, questionData, currentIndex } = this.state;

    if (selectedChoice) {
      let right_answer = 0;
      if (currentQuestion.correctChoice === selectedChoice) {
        right_answer = 1;
        this.setState({ textColor: 'text_success', result: 'Correct' });
      } else {
        this.setState({ textColor: 'text_failure', result: 'Incorrect' });
      }

      const data = {
        time_done: this.timerValue,
        question_id: currentQuestion.id,
        right_answer,
        selected_choice: selectedChoice,
      };

      saveQuestionStats(data).then(response => {
        if (response.success) {
          const existingStats = currentQuestion.esg_question_stats && currentQuestion.esg_question_stats[0] || {};
          const updatedQuestion = { 
            ...currentQuestion, 
            selectedChoice,
            esg_question_stats: [{
              ...existingStats,
              time_done: this.timerValue,
              selected_choice: selectedChoice,
              right_answer,
              id: response.id || (existingStats && existingStats.id),
              question_id: currentQuestion.id,
              user_id: existingStats.user_id
            }]
          };
          const updatedQuestionData = [...questionData];
          updatedQuestionData[currentIndex] = updatedQuestion;

          this.setState({
            currentQuestion: updatedQuestion,
            questionData: updatedQuestionData,
            showAnswer: true,
            stopTimer: true,
            timeDone: this.timerValue
          });
        }
      });
    }
  };

  setAnswer = answer => {
    this.setState({
      selectedChoice: answer[0],
    });
  };

  hideReportSection = () => {
    this.setState({ showReportSection: false });
  };

  onSaveItemChange = status => {
    this.setState({ isFlashCardHidden: status });
  };

  toggleReportSection = () =>
    this.setState(prevState => ({ showReportSection: !prevState.showReportSection }));

  render() {
    const {
      state: {
        stopTimer,
        questionData,
        currentQuestion,
        currentIndex,
        showReportSection,
        isLoading,
        showAnswer,
        selectedChoice,
        chapterName,
        isFlashCardHidden,
        textColor,
        result,
        timeDone
      },
    } = this;

    // Disable Validate if no choice is selected or answer is already shown
    const disableValidate = !selectedChoice || !!showAnswer;

    return (
      <LoaderWrapper isLoading={isLoading}>
        <div className='animated fadeIn font-lusitana font-16px'>
          <Header title={language.LC().QUESTION_BANK}>
            <CustomButton
              onClick={() => this.context.router.push({ pathname: AppRoutes.ESG_QUESTION_BANK })}
            >
              {language.LC().CHANGE_CHAPTER}{' '}
            </CustomButton>
          </Header>
          <Row>
            <Col>
              <CustomCard>
                <CardHeader
                  headingText={`${chapterName} (Q. ${currentQuestion && currentQuestion.id})`}
                  headerImage='/img/question_bank/question_icon_blue.svg'
                  showPreviousButton={true}
                  showNextButton={true}
                  currentIndex={currentIndex}
                  arrayLength={questionData.length}
                  disabledPreviousButton={currentIndex < 1}
                  disabledNextButton={!(currentIndex < questionData.length - 1)}
                  _getPrevious={this.getPreviousQuestion}
                  _getNext={this.getNextQuestion}
                />
                <CardBody>
                  <Row>
                    <Col sm={9} xs={12}>
                      <ViewQuestion
                        {...currentQuestion}
                        {...this.props}
                        setAnswer={this.setAnswer}
                        showAnswer={showAnswer}
                        selectedChoice={selectedChoice}
                      >
                        <QuestionBankFooter
                          key={currentQuestion && currentQuestion.id}
                          validateQuestion={this.validateQuestion}
                          favItemId={currentQuestion && currentQuestion.id}
                          setChildRef={this.childRef}
                          onSaveItemChange={this.onSaveItemChange}
                          toggleReportSection={this.toggleReportSection}
                          disabled={disableValidate}
                        />
                      </ViewQuestion>
                    </Col>
                    <Col sm={3} xs={12}>
                      <Timer
                        getTimerValue={this.getTimerValue}
                        stopTimer={stopTimer}
                        shouldFetchFromServer={true}
                        key={currentQuestion && currentQuestion.id}
                        initialTime={timeDone}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </CustomCard>
            </Col>
          </Row>
          {showAnswer && (
            <Row>
              <Col>
                <CustomCard className='font-lusitana font-16px'>
                  <CustomCardHeader
                    headingText={result}
                    headerImage=''
                    className={`text-uppercase ${textColor}`}
                  />
                  <CardBody>
                    {renderHTMLContent(
                      currentQuestion && currentQuestion.explanation,
                      'span'
                    )}
                  </CardBody>
                </CustomCard>
              </Col>
            </Row>
          )}
          <FlashCard
            item={currentQuestion}
            type='question'
            isFlashCardHidden={isFlashCardHidden}
            ref={this.setChildRef}
            exam='esg'
          />
          {showReportSection && (
            <Report
              hideReportSection={this.hideReportSection}
              commentOnWhichId={currentQuestion && currentQuestion.id}
            />
          )}
        </div>
      </LoaderWrapper>
    );
  }
}

export default BeginQuestion;



// WEBPACK FOOTER //
// ./src/views/ESG/QuestionBank/BeginQuestion.jsx